import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Octagon = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "octagon",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.3914 2.4686c.173-.173.2594-.2594.3603-.3212a1 1 0 0 1 .289-.1198C8.156 2 8.2783 2 8.5228 2h6.9546c.2445 0 .3668 0 .4819.0276a1 1 0 0 1 .2891.1198c.1009.0618.1874.1483.3603.3212l4.9228 4.9228c.1729.173.2594.2594.3212.3603a.9982.9982 0 0 1 .1198.289C22 8.156 22 8.2783 22 8.5228v6.9546c0 .2445 0 .3668-.0276.4819a.9981.9981 0 0 1-.1198.2891c-.0618.1009-.1483.1874-.3212.3603l-4.9228 4.9228c-.1729.1729-.2594.2594-.3603.3212a.9981.9981 0 0 1-.2891.1198C15.8441 22 15.7218 22 15.4773 22H8.5227c-.2446 0-.3668 0-.482-.0276a.9982.9982 0 0 1-.289-.1198c-.1009-.0618-.1874-.1483-.3603-.3212l-4.9228-4.9228c-.173-.1729-.2594-.2594-.3212-.3603a1 1 0 0 1-.1198-.2891C2 15.8441 2 15.7218 2 15.4773V8.5227c0-.2446 0-.3668.0276-.482a1 1 0 0 1 .1198-.289c.0618-.1009.1483-.1874.3212-.3603l4.9228-4.9228Z"
    })
  }));
};
export default Octagon;